<template>
  <v-container>
    <v-card class="elevation-5" style="padding:10px">
      <p class="b-title">Balance</p>

      <v-layout wrap>
        <v-flex xs11>
          <p v-if="balance" class="b-balance">Rp {{ balance }}</p>
          <p v-else class="b-loading">Loading...</p>
        </v-flex>
        <v-flex xs1>
          <div class="pt-2">
            <v-icon class="ref-btn" color="primary" @click="getBalance">
              mdi-update
            </v-icon>
          </div>
        </v-flex>
      </v-layout>

      <p v-if="balance" class="fs">
        Last Check: {{ date }}, {{ hour }} : {{ min }} : {{ sec }}
      </p>
      <p v-else class="fxl">Loading...</p>
      <router-link to="/topup?openModal=YES">
        <v-btn round color="success" dark class="text-capitalize">
          <v-icon class="pr-2" dark> mdi-plus-circle </v-icon>
          Top Up
        </v-btn>
      </router-link>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/helpers/axios'
import { mapState } from 'vuex'

export default {
  name: 'Balance',
  data () {
    return {
      balance: 0,
      date: '-',
      hour: '00',
      min: '00',
      sec: '00'
    }
  },
  computed: {
    ...mapState(['appid', 'appkey', 'token'])
  },
  methods: {
    getBalance () {
      this.$emit('loading', true)
      this.balance = null
      this.date = null
      this.hour = null
      this.min = null
      this.sec = null

      let appkey = this.appkey
      let appid = this.appid
      let accessToken = this.token
      let url = `/balance?app_id=${appid}&app_key=${appkey}&accesstoken=${accessToken}`

      axios
        .get(url)
        .then(response => {
          this.balance = response.data.data.balance
          let datecheck = response.data.data.date
          let arrange = datecheck.split(' ')[0]
          let months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
          ]
          this.date =
            arrange.split('-')[2] +
            ' ' +
            months[Number(arrange.split('-')[1]) - 1] +
            ' ' +
            arrange.split('-')[0]

          let hour = String(new Date().getHours())
          this.hour = hour.length === 1 ? '0' + hour : hour
          this.min = datecheck.split(' ')[1].split(':')[1]
          this.sec = datecheck.split(' ')[1].split(':')[2]
        })
        .catch(error => {
          if (error.response.data.code === 'TOE001') {
            this.$store.dispatch('refresh')
          }
          if (error.response.data.code === 'TOE002') {
            this.$store.dispatch('clear')
          }
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    }
  },
  mounted () {
    this.getBalance()
  }
}
</script>

<style scoped>
.ref-card:active,
.ref-card:hover {
  background: grey !important;
}

.ref-card:active .ref-btn,
.ref-card:hover .ref-btn {
  color: white;
  text-shadow: 0 0 8px 2px darkgrey;
}

.ref-card {
  position: absolute;
  right: 0;
  padding: 5px;
}

.b-title {
  font-weight: 200;
  font-size: medium;
}

.b-balance {
  font-weight: 1000;
  font-size: x-large;
}

.b-loading {
  font-size: medium;
}

.fs {
  font-size: small;
}

.fxl {
  font-size: x-large;
}
</style>
